module.exports = __webpack_public_path__ + "img/e71bab4.jpg";